export enum EntityActivityLogDescriptionKind {
  FieldChanged = 'fieldChanged',
  FieldToggled = 'fieldToggled',
  RelatedItemAdded = 'relatedItemAdded',
  RelatedItemDeleted = 'relatedItemDeleted',
  EntityCreated = 'entityCreated',
}

export type EntityActivityLogDescription =
  | {
      kind: EntityActivityLogDescriptionKind.FieldChanged;
      fieldLabel: string;
      oldValue: string;
      newValue: string;
    }
  | {
      kind: EntityActivityLogDescriptionKind.FieldToggled;
      fieldLabel: string;
      enabled: boolean;
      itemType?: string | null;
      name?: string;
    }
  | {
      kind:
        | EntityActivityLogDescriptionKind.RelatedItemAdded
        | EntityActivityLogDescriptionKind.RelatedItemDeleted;
      itemType: string;
      name: string;
    }
  | {
      kind: EntityActivityLogDescriptionKind.EntityCreated;
    };

export interface EntityActivityLogActionKeys {
  [EntityActivityLogDescriptionKind.FieldChanged]: string;
  [EntityActivityLogDescriptionKind.FieldToggled]: {
    on: string;
    off: string;
    onWithName?: string;
    offWithName?: string;
  };
  [EntityActivityLogDescriptionKind.RelatedItemAdded]: string;
  [EntityActivityLogDescriptionKind.RelatedItemDeleted]: string;
  [EntityActivityLogDescriptionKind.EntityCreated]: string;
}
